export default {"src":"/_next/static/media/Findnovelglobal-0001.e95f478d.svg","height":585,"width":850,"blurWidth":0,"blurHeight":0};